import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Callout, Column, ConfirmationModal } from 'seagull';
import { CopyToClipboard } from '~/components/CopyToClipboard/CopyToClipboard';
import { useLocaleKeys } from '~/i18n';
import styles from './CopyAPIKeyModal.module.scss';
const CopyAPIKeyModal = (param)=>{
    let { apiKeyName, apiKeyValue, dismissModal } = param;
    const { t: texts } = useLocaleKeys('pages.apiKeysPage');
    const { t: commonTexts } = useLocaleKeys('common');
    return /*#__PURE__*/ _jsx(ConfirmationModal, {
        bi: {
            primaryButton: {
                name: 'copy_a_p_i_key_confirm'
            },
            secondaryButton: {
                name: 'copy_a_p_i_key_cancel'
            }
        },
        title: texts.apiKeyTitle({
            keyName: apiKeyName
        }),
        testId: "copy-api-key-modal",
        width: "640px",
        content: /*#__PURE__*/ _jsxs(Column, {
            className: styles.container,
            children: [
                /*#__PURE__*/ _jsx(CopyToClipboard, {
                    value: apiKeyValue,
                    testId: "copy-api-key-button",
                    buttonLabel: texts.copyButtonLabel()
                }),
                /*#__PURE__*/ _jsx(Callout, {
                    testId: "copy-api-key-callout",
                    children: texts.copyCallout()
                })
            ]
        }),
        primaryButtonLabel: commonTexts.buttons.close(),
        onPrimaryButtonClick: dismissModal,
        onCloseButtonClick: dismissModal
    });
};
export default CopyAPIKeyModal;
